import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { resetService } from 'src/app/core/service/resetpassword/resetPassword';
import { MustMatch } from '../../directives/confirmed.validator.directive';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  resetForm: FormGroup;
  showPassword: boolean;
  passregex = '(?=.*)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%?=*&]).{8,}';
  hide: boolean;
  submitted = false;
  sendData: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
    private resetservice: resetService
  ) {}

  ngOnInit(): void {
    this.getUserId();
    this.formInit();
  }

  formInit(): void {
    this.resetForm = this.fb.group(
      {
        oldPassword: ['', [Validators.required]],
        userId: [this.sendData],
        newPassword: [
          '',
          [Validators.required, Validators.pattern(this.passregex)],
        ],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validator: MustMatch('newPassword', 'confirmPassword'),
      }
    );
  }

  get f() {
    return this.resetForm.controls;
  }
  // Login Method
  onchange(): void {
    this.submitted = true;
    if (this.resetForm.invalid) {
      return;
    }
    this.resetservice.changeOldPassword(this.resetForm.value).subscribe(
      (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message,
        });
        setTimeout(() => {
          sessionStorage.clear();
          this.router.navigateByUrl('/login');
        }, 3000);
      }
      // (error: HttpErrorResponse) => {
      //   if (error.status == 400) {
      //     this.messageService.add({
      //       severity: 'error',
      //       summary: 'Error',
      //       detail: error.error.message,
      //     });
      //   }
      // }
    );
  }

  toggleFieldTextType() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordType() {
    this.hide = !this.hide;
  }

  getUserId() {
    var stringArr = sessionStorage.getItem('userId');
    var fin = JSON.parse(stringArr);
    this.sendData = fin;
  }
}
